Vue.component('admin-reward-points', {
    template: templates.adminRewardPoints,
    data() {
      return {
        model: {
          rewards_points: {},
          points_config: [],
          reward_points: {
            name: '',
            value: 0
          },
          edit: false,
          config_edit: false,
          points_config_form: {
            id: null,
            activity_type: '',
            activity_name: '',
            points_value: 0,
            description: '',
            active: 1
          }
        }
      }
    },
    mounted() {
        const c = this;

        c.get();
        c.getPointsConfig();
    },
    methods: {
      get() {
        const c = this;
        let data = {};
  
        rewardService.get()
          .then(function (response) {
            
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
            c.model.rewards_points = data;

          })
          .catch(function (error) {
            //console.log(error);
          });
      },
      getPointsConfig() {
        const c = this;

        axios.get('/api/admin/rewards/points-config.php')
          .then(function (response) {
            if (response.data.success) {
              c.model.points_config = response.data.data || [];
            }
          })
          .catch(function (error) {
            console.error('Failed to load points config:', error);
          });
      },
        add(){
          const c = this;

          c.model.edit = true;
        },
        edit(id) {
          const c = this;
          c.model.edit = true;
          let data = c.model.rewards_points[`${id}`];

          c.model.reward_points = {
            id:id,
            name: data.name,
            value: data.value,
          }

          console.log(c.model)
        },
        save(){
          const c = this;

          const data =  c.model.reward_points;

          if (!data.name) {
            utils.alert.error('Name is required');
            return;
          }

          if (!data.value) {
            utils.alert.error('Points is required');
            return;
          }

          rewardService.save(data)
          .then(function (response) {
            c.get()
            c.reset();
            console.log(response)
            
          })
          .catch(function (error) {
            utils.alert.error('Failed to save.');
          });

        },
        reset(){
          const c = this
          c.model.edit = false

          c.model.reward_points = {
            name: '',
            value: 0
          }
        },
        addPointsConfig(){
          const c = this;
          c.model.config_edit = true;
          c.model.points_config_form = {
            id: null,
            activity_type: '',
            activity_name: '',
            points_value: 0,
            description: '',
            active: 1
          };
        },
        editPointsConfig(config){
          const c = this;
          c.model.config_edit = true;
          c.model.points_config_form = {
            id: config.id,
            activity_type: config.activity_type,
            activity_name: config.activity_name,
            points_value: config.points_value,
            description: config.description,
            active: config.active
          };
        },
        savePointsConfig(){
          const c = this;
          const data = c.model.points_config_form;

          if (!data.activity_type) {
            utils.alert.error('Activity Type is required');
            return;
          }

          if (!data.activity_name) {
            utils.alert.error('Activity Name is required');
            return;
          }

          if (!data.points_value) {
            utils.alert.error('Points Value is required');
            return;
          }

          const url = data.id ? '/api/admin/rewards/update-points-config.php' : '/api/admin/rewards/add-points-config.php';

          axios.post(url, data)
            .then(function (response) {
              if (response.data.success) {
                c.getPointsConfig();
                c.resetPointsConfigForm();
                utils.alert.success(data.id ? 'Points config updated successfully' : 'Points config added successfully');
              } else {
                utils.alert.error(response.data.message || 'Failed to save');
              }
            })
            .catch(function (error) {
              console.error('Error saving points config:', error);
              utils.alert.error('Failed to save points configuration');
            });
        },
        resetPointsConfigForm(){
          const c = this;
          c.model.config_edit = false;
          c.model.points_config_form = {
            id: null,
            activity_type: '',
            activity_name: '',
            points_value: 0,
            description: '',
            active: 1
          };
        }

    }
  });